import { PedidosState } from ".";

const getters = {
    selectedFilters: (state:PedidosState) => state.selectedFilters,
};

export default getters;